import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const validateDOB = (value: string) => {
  const regex = /^(0[1-9]|1[0-2])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\d{2}$/;
  if (!regex.test(value)) return 'Date must be in MM/DD/YYYY format';

  const [month, day, year] = value.split('/').map(Number);

  if (month < 1 || month > 12) return 'Invalid month';
  if (day < 1 || day > 31) return 'Invalid day';
  if (year < 1900 || year > new Date().getFullYear()) return 'Invalid year';

  const daysInMonth = new Date(year, month, 0).getDate();
  if (day > daysInMonth) return 'Invalid day for this month';

  const today = new Date();
  const birthDate = new Date(year, month - 1, day);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age -= 1;
  }

  if (age < 18) return 'You must be older than 18';

  return true;
};

export function validateAndFormatUSPhoneNumber(
  value: string
): boolean | string {
  const modifiedValue = value.replace(/\D/g, '');

  const phoneNumber = parsePhoneNumberFromString(modifiedValue, 'US');

  if (!phoneNumber || !phoneNumber.isValid() || phoneNumber.country !== 'US') {
    return 'Invalid US phone number';
  }

  return true;
}

export function validateSSN(ssn: string) {
  const digits = ssn.replace(/\D/g, '');
  const errorMessage = 'Invalid social security number';
  if (digits.length !== 9) return errorMessage;

  if (/^(\d)\1{8}$/.test(digits)) return errorMessage;

  const area = digits.slice(0, 3);
  const group = digits.slice(3, 5);
  const serial = digits.slice(5, 9);

  if (area === '000' || area === '666' || area.startsWith('9'))
    return errorMessage;

  if (group === '00') return errorMessage;

  if (serial === '0000') return errorMessage;

  if (digits === '123456789') return errorMessage;

  return true;
}

export function formatSSN(value: string) {
  const cleanValue = value.replace(/\D/g, '');
  if (cleanValue.length <= 3) return cleanValue;
  if (cleanValue.length <= 5)
    return `${cleanValue.slice(0, 3)}-${cleanValue.slice(3)}`;
  return `${cleanValue.slice(0, 3)}-${cleanValue.slice(3, 5)}-${cleanValue.slice(5, 9)}`;
}

export const unformatSSN = (formattedValue: string) =>
  formattedValue.replace(/\D/g, '');
